import { Message } from "@/app/store/types";
import React from "react";

/**
 * RichText 组件
 * 用于渲染富文本消息内容
 * 支持 HTML、Markdown 等格式
 */
export default React.memo(
  function RichText(props: { msg: Message }) {
    // 4. 使用 DangerouslySetInnerHTML 组件渲染富文本
    return <div dangerouslySetInnerHTML={{ __html: props.msg.content }}></div>;
  },
  // 自定义 props 比较函数，优化性能
  (prevProps, nextProps) => {
    // 仅当 msg.content 发生变化时才重新渲染
    return prevProps.msg.content === nextProps.msg.content;
  },
);
